import { lazy, memo } from "react";

import { useAuthenticatedUser } from "contexts/useAuthenticatedUserContext";
import { hasOrganizationPrivileges, isAdmin, isCollector } from "typings/Role";

const OrganizationAppBar = lazy(
  () => import("components/Layout/OrganizationAppBar"),
);
const CollectorAppBar = lazy(() => import("components/Layout/CollectorAppBar"));
const AdminAppBar = lazy(() => import("components/Layout/AdminAppBar"));

const AuthenticatedAppBar = () => {
  const { role } = useAuthenticatedUser();

  if (isCollector(role)) {
    return <CollectorAppBar />;
  }

  if (isAdmin(role)) {
    return <AdminAppBar />;
  }

  if (hasOrganizationPrivileges(role)) {
    return <OrganizationAppBar />;
  }

  return null;
};

export default memo(AuthenticatedAppBar);
